module.exports = __webpack_public_path__ + "static/media/financial_health.361da6db.jpg";